import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../components/ui/button/Buttons";
import { addPendingContractsConfig } from "./AddPendingContracts.formfield.config";
import { setDropdownOptions } from "../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { setFieldSetting } from "../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../components/finalForms/libs/data/fieldSettingType";
import ToastService from "../../../../../services/toastService/ToastService";
import { useAddPendingContractMutation, useGetActiveClientsMutation } from "../../../../../app/services/pendingContractAPI";
import { useLazyGetAllContractTypeQuery } from "../../../../../app/services/contractAPI";

const AddPendingContract = ({ isOpen, onClose }) => {
  const PendingContractref = useRef();
  const [pendingContractForm, setPendingContractForm] = useState(addPendingContractsConfig);

  const [getActiveClients, {
    isFetching: getActiveClientsFetching,
    isSuccess: getActiveClientsFetched,
    data: getActiveClientsData,
  },] = useGetActiveClientsMutation();


  const [getAllContractType, {
    isSuccess: isAllContractTypeFetched,
    data: AllContractTypeData
  }] = useLazyGetAllContractTypeQuery();

  const [addPendingContract, {
    isFetching: addPendingContractLoading,
    isSuccess: addPendingContractFetched,
    data: addPendingContractData,
  },] = useAddPendingContractMutation();


  useEffect(() => {
    const request = {
      pbIncludeNone: true,
      plClientKeyToInclude: 0
    };
    getActiveClients(request);
    getAllContractType(true);
    setFieldSetting(pendingContractForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, true);
    setFieldSetting(pendingContractForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (!getActiveClientsFetching && getActiveClientsFetched && getActiveClientsData) {
      setDropdownOptions(getActiveClientsData, 'lClientKey', 'sClientName1', pendingContractForm, 'lClientKey', setPendingContractForm);
      setFieldSetting(pendingContractForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getActiveClientsFetching, getActiveClientsFetched, getActiveClientsData]);

  useEffect(() => {
    if (isAllContractTypeFetched && AllContractTypeData) {
      setDropdownOptions(AllContractTypeData, 'lContractTypeKey', 'sContractType', pendingContractForm, 'lContractTypeKey', setPendingContractForm);
      setFieldSetting(pendingContractForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllContractTypeFetched, AllContractTypeData])

  useEffect(() => {
    if (addPendingContractFetched && addPendingContractData) {
      if (addPendingContractData) {
        ToastService.success(addPendingContractData?.errorMessage);
        onClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addPendingContractFetched, addPendingContractData]);

  const handleFieldChange = (dataField, updatedData) => {
    const { lClientKey, lContractTypeKey } = updatedData;
    if (dataField === 'lClientKey' || dataField === 'lContractTypeKey') {
      const newFormData = {
        ...pendingContractForm,
        initialState: {
          ...updatedData,
        },
      }
      newFormData.initialState.sContractName = `${lClientKey?.label || ''} - ${lContractTypeKey?.label || ''}`;
      setPendingContractForm(newFormData);
    }
  }

  const extractValue = (field) => {
    return field && typeof field === "object" ? field.value : field;
  };

  const handleSaveClick = () => {
    const formData = PendingContractref.current.getFormData();

    if (!formData) {
      ToastService.error("Please fill all required fields");
      return;
    }

    const request = {
      plClientKey: extractValue(formData.lClientKey),
      plContractTypeKey: extractValue(formData.lContractTypeKey),
      psPendingContractName: formData.sContractName
    }
    addPendingContract(request);

  }

  return (
    <div>
      <FormCreator
        ref={PendingContractref}
        config={pendingContractForm}
        onColumnChange={handleFieldChange}
      />
      <div className="d-flex justify-content-center button-submit">
        <Buttons
          buttonText="Save"
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handleSaveClick}
          isLoading={addPendingContractLoading}
        />
        <Buttons
          buttonText="Cancel"
          buttonTypeClassName="btn secondary-btn ml-4"
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default AddPendingContract;
